import{jsxs as t,jsx as i}from"react/jsx-runtime";import{styled as p}from"styled-components";import{TITLE_AREA as e}from"../constants/ElementId.mjs";const n=p.div`
  min-height: 40px;
  padding: 0px;
  margin-bottom: 2px;
  border-bottom: 1px solid #999999;
  box-shadow: 0px 1px 2px #ccc;
  background: url('images/titlebar.png') repeat-x #fff;
`,o=p.h2`
  color: #666;
  min-width: 400px;
  max-width: 730px;
  height: 30px;
  padding-top: 8px;
  padding-left: 80px;
  font-size: 15px;
  text-shadow: 1px 1px 2px #999999;
  margin: 0px;
  float: left;
`,d=p.div`
  width: 200px;
  height: 32px;
  padding: 0px;
  float: right;

  * {
    float: right;
  }
`,r=p.div`
  clear: left;
  padding: 0px;
  margin: 0px;
`;function x({title:p,myMenu:x,subMenu:a}){return t(n,{id:e,children:[i(o,{id:"top",className:"title",children:p}),x&&i(d,{className:"menubar",children:x}),a&&i(r,{children:a})]})}export{x as TitleArea};
